import * as React from 'react';
const SvgMinusCircleFill = props => (
  <svg
    className="bi bi-dash-circle-fill"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z" />
  </svg>
);
export default SvgMinusCircleFill;
